import request from "@/utils/request";

// 获取圈子申请列表API
export const GetCreateCircleList = (params) => {
  return request({
    url: "/admin/circle/admin/GetCreateCircleList",
    method: "get",
    params,
  });
};

// 审批圈子申请API
export const SetCreateCircleApplication = (data) => {
  return request({
    url: "/circle/saveOrUpdate",
    method: "post",
    data,
  });
};

// 获取圈子禁言列表API
export const GetCreateMuteListApi = (params) => {
  return request({
    url: "/mute/admin/page",
    method: "get",
    params,
  });
};

// 禁言解封
export const setMuteLiberatedApi = (id) => {
  return request({
    url: "/mute/admin/mute/liberated/" + id,
    method: "put",
  });
};

// 获取帖子举报列表API /admin/report/GetReportList
export const getReportListApi = (params) => {
  return request({
    url: "/report/page",
    method: "get",
    params,
  });
};

// 获取钱包购买配置列表API
export const getWalletInfoApi = (params) => {
  return request({
    url: "/wallet/info/page",
    method: "get",
    params: params,
  });
};

// 修改钱包购买配置API
export const modifyWalletInfoApi = (data) => {
  return request({
    url: "/wallet/info/saveOrUpdate",
    method: "post",
    data,
  });
};

// 新增钱包购买配置API
export const addWalletInfoApi = (data) => {
  return request({
    url: "/wallet/info/saveOrUpdate",
    method: "post",
    data,
  });
};

// 删除钱包购买配置API
export const deleteWalletInfoApi = (id) => {
  return request({
    url: "/wallet/info/" + id,
    method: "delete",
  });
};

// 获取圈管理员列表
export const getCircleAdminApi = (params) => {
  return request({
    url: "/circle/admin/admin/GetadminList",
    method: "get",
    params,
  });
};

// 审核圈管理员
export const auditCircleAdminApi = (data) => {
  return request({
    url: "/circle/admin/audit/cirlceAdmin",
    method: "post",
    data
  });
};

// 当前用户解封
export const setBanLiberatedApi = (id) => {
  return request({
    url: "/ban/admin/liberated/" + id,
    method: "put",
  });
};

// 新增封禁
export const addBanUserApi = (data) => {
  return request({
    url: "/ban/admin",
    method: "post",
    data,
  });
};

// 禁言操作
export const setUserMuteApi = (data) => {
  return request({
    url: "/mute/admin",
    method: "post",
    data,
  });
};

// 删除举报记录
export const deleteReportApi = (id) => {
  return request({
    url: "/report/" + id,
    method: "delete",
  });
};

// 获取圈子申请列表API
export const getExamineJoinListApi = (params) => {
  return request({
    url: "/circle/admin/work/GetExamineJoinList",
    method: "get",
    params
  });
};

// 提交圈子成员审核API
export const setExamineJoin = (data) => {
  return request({
    url: "/circle/admin/audit/join",
    method: "post",
    data
  });
};

// 审核举报
export const auditReportApi = (data) => {
  return request({
    url: "/report/audit",
    method: "post",
    data
  });
};

// 评论举报处置
export const handleCommentReportApi = (data) => {
  return request({
    url: "/report/comment/action",
    method: "post",
    data
  });
};

// 通过id查询广场所属圈子 /square/circle/page
export const getSquareCircleApi = (params) => {
  return request({
    url: "/square/circle/page",
    method: "get",
    params
  });
};

// /updateCircleStatus 变更圈子审核状态
export const updateCircleStatusApi = (data) => {
  return request({
    url: "/circle/updateCircleStatus",
    method: "post",
    data
  });
};
